"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _processRichText = _interopRequireDefault(require("../utils/process-rich-text"));
var _standard = _interopRequireDefault(require("../utils/rich-text-factories/standard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var createConsultationAppointmentBooking = function createConsultationAppointmentBooking(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  var bookingCopyDoc = (0, _utils.getProp)(fields, 'bookingCopy');
  var bookingCopy = bookingCopyDoc ? (0, _processRichText["default"])({
    document: bookingCopyDoc,
    factories: _standard["default"]
  }) : null;
  var bookedCopyTopDoc = (0, _utils.getProp)(fields, 'bookedCopyTop');
  var bookedCopyTop = bookedCopyTopDoc ? (0, _processRichText["default"])({
    document: bookedCopyTopDoc,
    factories: _standard["default"]
  }) : null;
  var bookedCopyBottomDoc = (0, _utils.getProp)(fields, 'bookedCopyBottom');
  var bookedCopyBottom = bookedCopyBottomDoc ? (0, _processRichText["default"])({
    document: bookedCopyBottomDoc,
    factories: _standard["default"]
  }) : null;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    site: (0, _utils.getProp)(fields, 'site'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    bookingCopy: bookingCopy,
    bookedCopyTop: bookedCopyTop,
    bookedCopyBottom: bookedCopyBottom
  };
};
var _default = createConsultationAppointmentBooking;
exports["default"] = _default;